export interface StructuredData {
  '@context': string;
  '@type': string;
  [key: string]: unknown;
}

export function injectStructuredData(data: StructuredData | StructuredData[]) {
  const existing = document.getElementById('structured-data');
  if (existing) {
    existing.remove();
  }
  const script = document.createElement('script');
  script.id = 'structured-data';
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
}

export function clearStructuredData() {
  const existing = document.getElementById('structured-data');
  if (existing) {
    existing.remove();
  }
}